// extracted by mini-css-extract-plugin
module.exports = {"viaplay-video":"ViaplayVideo_viaplay-video___8Zfa","frame":"ViaplayVideo_frame__CDbna"};